import { Journals } from './Journals.types';

export enum AgreementIsActive {
  pending = 'pending',
  expired = 'expired',
  active = 'active',
  inactive = 'inactive',
}

// Metadata that's part of all entities
export type EntityMetadata = {
  readonly _id?: string;
  readonly updated_at?: string;
  readonly updated_by?: string;
  readonly file_updated_at?: string;
  readonly file_updated_by?: string;
  readonly file_name?: string;
  readonly account?: string;
  readonly journals?: Journals[];
  readonly journals_count?: number;
  readonly computed_status?: AgreementIsActive;
};

export type AgreementStatus = 'enabled' | 'disabled';

// Core agreement data from API
export type Agreements = EntityMetadata & {
  // Required fields (validated on form)
  name: string; // Agreement name (shown as "Agreement Title" in UI)
  publisher: string;
  payment: string;
  start_date: string;
  end_date: string;

  // Optional fields
  collections?: string[];
  payment_url?: string;
  licenses?: string[];
  extra_info?: string;
  status?: AgreementStatus;
  description?: Record<string, string>;
  notes?: string;
};

// Form state type - all fields optional during editing
export type AgreementFormData = Partial<
  Omit<
    Agreements,
    keyof EntityMetadata | 'journals' | 'journals_count' | 'status'
  >
>;
